/**
 * Define action creators here 'actions.ts'
 */
/** *** */
import { postBrandInviteRetailers, postRepInviteBrands, postRepInviteRetailers } from "src/util/apiNew";
import { tAcceptConnectionRequestArgs, tInviteRetailersRequestBody } from "tmt_api/src/types/types";
import api from "../../util/api";
import { handleErrorEvents } from "../errorHandler/actions";
import { tReduxAction } from "../types";
import type { tSetStatusAction, tStatus } from "./types";

type tpSetStatus = (status: tStatus) => tSetStatusAction;
export const setStatus: tpSetStatus = (status) => {
  return { type: "SET_STATUS", data: { status } };
};

type tpAcceptConnectionRequest = (myParams: {
  brandId: string;
  boutiqueId: string;
  connectionArgs: tAcceptConnectionRequestArgs;
  onComplete?: () => void;
  onError?: (error: Error) => void;
}) => tReduxAction;
export const acceptConnectionRequest: tpAcceptConnectionRequest =
  ({
    brandId: myBrandId,
    boutiqueId: myBoutiqueId,
    connectionArgs: myConnectionArgs,
    onComplete: myOnComplete,
    onError: myOnError,
  }) =>
  (dispatch) => {
    dispatch({
      type: "SET_LOADING_CONNECTIONS",
      loading: true,
    });
    return api
      .put({ endpoint: `/brands/${myBrandId}/connections/${myBoutiqueId}/accept` as const, body: myConnectionArgs })
      .then(() => {
        dispatch(handleErrorEvents("A connection has been accepted", "success"));
        if (myOnComplete) {
          myOnComplete();
        }
      })
      .catch((error: Error) => {
        dispatch(handleErrorEvents(error.message, "error", error));
        if (myOnError) {
          myOnError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: "SET_LOADING_CONNECTIONS",
          loading: false,
        });
      });
  };

type tpDeclineConnectionRequest = (myParams: {
  brandId: string;
  boutiqueId: string;
  onComplete?: () => void;
  onError?: (error: Error) => void;
}) => tReduxAction;
export const declineConnectionRequest: tpDeclineConnectionRequest =
  ({ brandId: myBrandId, boutiqueId: myBoutiqueId, onComplete: myOnComplete, onError: myOnError }) =>
  (dispatch) => {
    dispatch({
      type: "SET_LOADING_CONNECTIONS",
      loading: true,
    });
    return api
      .put({
        endpoint: `/brands/${myBrandId}/connections/${myBoutiqueId}/decline` as const,
      })
      .then(() => {
        dispatch(handleErrorEvents("A connection has been declined", "success"));
        if (myOnComplete) {
          myOnComplete();
        }
      })
      .catch((error: Error) => {
        dispatch(handleErrorEvents(error.message, "error", error));
        if (myOnError) {
          myOnError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: "SET_LOADING_CONNECTIONS",
          loading: false,
        });
      });
  };

type tpCancelConnectionRequest = (myParams: {
  brandId: string;
  boutiqueId: string;
  connectionId: string;
  onComplete?: () => void;
  onError?: (error: Error) => void;
}) => tReduxAction;
export const cancelConnectionRequest: tpCancelConnectionRequest =
  ({
    brandId: myBrandId,
    boutiqueId: myBoutiqueId,
    connectionId: myConnectionId,
    onComplete: myOnComplete,
    onError: myOnError,
  }) =>
  (dispatch) => {
    dispatch({
      type: "SET_LOADING_CONNECTIONS",
      loading: true,
    });
    return api
      .put({
        endpoint: `/brands/${myBrandId}/boutiques/${myBoutiqueId}/connections/${myConnectionId}/cancel` as const,
      })
      .then(() => {
        if (myOnComplete) {
          myOnComplete();
        }
      })
      .catch((error: Error) => {
        dispatch({
          type: "ERROR",
          error,
        });

        if (myOnError) {
          myOnError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: "SET_LOADING_CONNECTIONS",
          loading: false,
        });
      });
  };

type tpDeactivateConnection = (myParams: {
  brandId: string;
  boutiqueId: string;
  onComplete?: () => void;
  onError?: (error: Error) => void;
}) => tReduxAction;
export const deactivateConnection: tpDeactivateConnection =
  ({ brandId: myBrandId, boutiqueId: myBoutiqueId, onComplete: myOnComplete, onError: myOnError }) =>
  (dispatch) => {
    dispatch({
      type: "SET_LOADING_CONNECTIONS",
      loading: true,
    });
    return api
      .put({
        endpoint: `/brands/${myBrandId}/connections/${myBoutiqueId}/status` as const,
        body: {
          status: "Deactivated",
        },
      })
      .then(() => {
        dispatch(handleErrorEvents("A connection has been deactivated", "success"));
        if (myOnComplete) {
          myOnComplete();
        }
      })
      .catch((error: Error) => {
        dispatch(handleErrorEvents(error.message, "error", error));
        if (myOnError) {
          myOnError(error);
        }
      })
      .finally(() => {
        dispatch({
          type: "SET_LOADING_CONNECTIONS",
          loading: false,
        });
      });
  };

export const brandInviteRetailers = (
  brandId: string,
  payload: tInviteRetailersRequestBody,
): tReduxAction<Promise<{ error: string }>> => {
  return () => postBrandInviteRetailers(brandId, payload);
};

export const repInviteRetailers = (
  repId: string,
  payload: tInviteRetailersRequestBody,
): tReduxAction<Promise<{ error: string }>> => {
  return () => postRepInviteRetailers(repId, payload);
};

export const repInviteBrands = (
  repId: string,
  payload: tInviteRetailersRequestBody,
): tReduxAction<Promise<{ failedEmails: string[]; existingEmails: string[] }>> => {
  return () => postRepInviteBrands(repId, payload);
};
